// import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { HttpHeaders } from '@angular/common/http';
// import { environment } from '../Environment';
// import { DatePipe } from '@angular/common';
// @Injectable({
//   providedIn: 'root'
// })
// export class TimesheetService {
//   constructor(private httpClient: HttpClient,
//     private datePipe: DatePipe
//   ) { }
//   apiURL = environment.baseUrl;
//   private getRandomAuthorizationKey(): string {
//     const keys = environment.AuthorizationKeys;
//     const randomIndex = Math.floor(Math.random() * keys.length);
//    // alert(`Using Authorization Key: ${randomIndex}`);
//     return keys[randomIndex];
//   }
//   GetTasks(id: any) {

//     const currentDate = new Date();
//     const incrementedDate = new Date(currentDate.setDate(currentDate.getDate() + 45));
//     const formattedIncrementedDate = this.datePipe.transform(incrementedDate, 'yyyy-MM-dd');
//     let TaskUrl = 'https://app.celoxis.com/psa/api/v2/tasks?filter={"resources":"' + id + '","actualPercentComplete":"<100","plannedFinish":"<'+formattedIncrementedDate+'"}';

//     const headers = new HttpHeaders({
//       'Authorization': this.getRandomAuthorizationKey(),
//       //'Authorization': 'EdRKb9nYgGiqLgiULjC5scu161r7UKHMaP6i6EDQ',
//       'Content-Type': 'application/json;charset=UTF-8',
//       'Accept': '*/*',
//     });

//     return this.httpClient.get(TaskUrl, { headers: headers })
//   }

//   private AddTimesheetdataUrl = this.apiURL + 'TimeSheetData/AddTimeSheet'
//   private GetTimesheetdataUrl = this.apiURL + 'TimeSheetData/GetTimesheet'
//   private GetNonBillOptionsUrl=this.apiURL + 'TimeSheetData/GetNonBillOptions'

//   AddTimeSheetDetail(Detail: any) {
//     var req = this.AddTimesheetdataUrl;
//     var headers=new HttpHeaders({
//       // 'Authorization': 'EdRKb9nYgGiqLgiULjC5scu161r7UKHMaP6i6EDQ',
//       'Content-Type': 'application/json;charset=UTF-8',
//       'Accept': '*/*',
//     })
    
//     var body={Detail}
//     return this.httpClient.post(req, body, { headers: headers });
//   }

//   GetTimeSheet(uid:any,startweek:any,endweek:any){
//     var req=this.GetTimesheetdataUrl;
//     //  var req='https://timesheet.aptaracorp.net/CeloxisAPI/api/TimeSheetData/GetTimesheet'
//     var body={UserID:uid,StartWeek:startweek,EndWeek:endweek}
//     return this.httpClient.post(req,body);
//   }
//   getNonBillOptions(){
//     var req=this.GetNonBillOptionsUrl;
//     return this.httpClient.get(req);
//   }
// }
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, retry, catchError, throwError } from 'rxjs';
import { DatePipe } from '@angular/common';
import { environment } from '../Environment';

@Injectable({
  providedIn: 'root'
})
export class TimesheetService {

  constructor(
    private http: HttpClient,
    private datePipe: DatePipe
  ) {}

  apiUrl = environment.baseUrl;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      'Accept': '*/*'
    })
  };

  private getRandomAuthorizationKey(): string {
    const keys = environment.AuthorizationKeys;
    const randomIndex = Math.floor(Math.random() * keys.length);
    return keys[randomIndex];
  }

  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(() => errorMessage);
  }


  private readonly addTimesheetApi =
    this.apiUrl + 'TimeSheetData/AddTimeSheet';

  private readonly getTimesheetApi =
    this.apiUrl + 'TimeSheetData/GetTimesheet';

  private readonly getNonBillOptionsApi =
    this.apiUrl + 'TimeSheetData/GetNonBillOptions';
   
  private readonly getTask =
    this.apiUrl + 'celoxis/get-tasks';

  private readonly getAppConfigApi =
    this.apiUrl + 'TimeSheetData/GetAppConfiguration';

  private readonly getUserValidityApi = this.apiUrl + 'TimeSheetData/GetUserValidity';

  // GetTasks(resourceId: any): Observable<any> {
  //   const currentDate = new Date();
  //   const incrementedDate = new Date(
  //     currentDate.setDate(currentDate.getDate() + 45)
  //   );

  //   const formattedDate =
  //     this.datePipe.transform(incrementedDate, 'yyyy-MM-dd');

  //   const taskUrl =
  //     `https://app.celoxis.com/psa/api/v2/tasks?filter=` +
  //     `{"resources":"${resourceId}","actualPercentComplete":"<100","plannedFinish":"<${formattedDate}"}`;

  //   const headers = new HttpHeaders({
  //     'Authorization': this.getRandomAuthorizationKey(),
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     'Accept': '*/*'
  //   });

  //   return this.http
  //     .get(taskUrl, { headers })
  //     .pipe(retry(1), catchError(this.handleError));
  // }

  GetTasks(id: any) {
  const body = {
    resourceId: id,
    authorizationKey: this.getRandomAuthorizationKey()
  };
 
  return this.http.post(
    this.getTask,
    body
  );
}


  AddTimeSheetDetail(detail: any): Observable<any> {
    const body = { Detail: detail };

    return this.http
      .post(this.addTimesheetApi, body, this.httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  GetTimeSheet(
    userId: any,
    startWeek: any,
    endWeek: any
  ): Observable<any> {
    const body = {
      UserID: userId,
      StartWeek: startWeek,
      EndWeek: endWeek
    };

    return this.http
      .post(this.getTimesheetApi, body, this.httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  getNonBillOptions(): Observable<any> {
    return this.http
      .get(this.getNonBillOptionsApi, this.httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  getAppConfiguration(): Observable<any> {
    return this.http
      .get(this.getAppConfigApi, this.httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

   getUserValidity(email: string): Observable<any> {
    const body = {
      Email: email
    };

    return this.http
      .post(this.getUserValidityApi, body, this.httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }
}
